module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/PHYSICS-THEORETICAL PHYSICS-f752a5e4ef0d2fc2e88993ace47a2ff7.png";